import React from 'react';
import classNames from 'classnames';
import { ReactComponent as QuestionIcon } from 'assets/icons/questionIcon.svg';

import styles from './styles/tooltip.module.scss';

const Tooltip = ({ toolTipMessage = '', className = '', children }) => {
  const tooltipClassName = classNames({
    [styles.tooltip]: true,
    [className]: Boolean(className),
  });

  return (
    <>
      {toolTipMessage ? (
        <span className={tooltipClassName}>
          <span className={styles.tooltip__children}>
            {children ? (
              children
            ) : (
              <span className={styles.tooltip__icon}>
                <QuestionIcon />
              </span>
            )}
          </span>
          <span className={styles.tooltip__text}>{toolTipMessage}</span>
        </span>
      ) : null}
    </>
  );
};

export default Tooltip;
